import { useCallback, useEffect, useState } from 'react'

import { getAPIClient } from 'api/axios'

import { Coupon, CouponListParams } from '../types/coupon'

// O /v1/coupons pagina com `.page(params[:page])` sem `.per`, então sem esse
// valor explícito a listagem para nos 25 primeiros (default do Kaminari) — e
// nem o drawer nem o autocomplete têm paginação pra alcançar o resto.
const DEFAULT_PER_PAGE = 100

interface UseListCouponsState {
  coupons: Coupon[]
  meta: { total: number; page: number }
  loading: boolean
  error: string | null
}

export const useListCoupons = (params?: CouponListParams) => {
  const [state, setState] = useState<UseListCouponsState>({
    coupons: [],
    meta: { total: 0, page: 1 },
    loading: false,
    error: null
  })

  const client = getAPIClient()

  const fetchCoupons = useCallback(
    async (overrideParams?: CouponListParams) => {
      setState((prev) => ({ ...prev, loading: true, error: null }))

      const queryParams = { ...params, ...overrideParams }
      const searchParams = new URLSearchParams()

      if (queryParams?.status) {
        searchParams.set('status', queryParams.status)
      }
      if (queryParams?.search) {
        searchParams.set('search', queryParams.search)
      }
      if (queryParams?.page) {
        searchParams.set('page', String(queryParams.page))
      }
      searchParams.set('per', String(queryParams?.per ?? DEFAULT_PER_PAGE))

      const queryString = searchParams.toString()
      const url = `/v1/coupons${queryString ? `?${queryString}` : ''}`

      try {
        const response = await client.get(url)
        const data = response.data

        const rawCoupons: Coupon[] = data.coupons || data.records || []
        const coupons = rawCoupons.map((c: any) => ({
          ...c,
          discount_value: Number(c.discount_value),
          max_discount: c.max_discount != null ? Number(c.max_discount) : null
        }))

        setState({
          coupons,
          meta: data.meta || { total: 0, page: 1 },
          loading: false,
          error: null
        })
      } catch (err: any) {
        setState((prev) => ({
          ...prev,
          loading: false,
          error: err?.response?.data?.message || 'Erro ao carregar cupons'
        }))
      }
    },
    [params?.status, params?.search, params?.page, params?.per]
  )

  useEffect(() => {
    fetchCoupons()
  }, [fetchCoupons])

  return {
    ...state,
    refetch: fetchCoupons
  }
}
